"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../constants");
var SubSectionHeader = _styledComponents["default"].h3.withConfig({
  displayName: "sub_section_header__SubSectionHeader"
})(["font-family:Untitled Sans,sans-serif;font-size:16px;line-height:24px;color:", ";", ""], _constants.colors.darkestGrey, (0, _constants.fontWeight)('heavy'));
var _default = exports["default"] = SubSectionHeader;